import { forwardRef, useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import { isDefined } from 'utils/tsHelpers';
import { SelectValueDisplayProps, SelectValueType } from 'ui/selects';
import { StyledPurpleSecondaryButton } from 'modules/predictiveGoals/components/queryBuilder/components/pgQueryBuilderEnhancements/styles';

type TriggerProps = Pick<
  SelectValueDisplayProps<SelectValueType>,
  'selectedOptions' | 'toggleDropdown' | 'placeholder' | 'suffixUsed' | 'isDisabled' | 'isOpen'
>;

export const PurpleSelectTrigger = forwardRef<HTMLButtonElement, TriggerProps>(
  (
    { isDisabled, isOpen = false, placeholder, selectedOptions = [], suffixUsed, toggleDropdown },
    ref,
  ) => {
    const { Suffix, label } = selectedOptions[0] ?? {};
    const content = useMemo(() => {
      const value = suffixUsed && isDefined(Suffix) ? Suffix : label;
      return value ?? placeholder;
    }, [selectedOptions]);
    const inputIsEmpty = isEmpty(selectedOptions);
    return (
      <StyledPurpleSecondaryButton
        data-empty={inputIsEmpty}
        data-filled={!inputIsEmpty}
        data-open={isOpen}
        ref={ref}
        onClick={() => toggleDropdown()}
        isDisabled={isDisabled}
      >
        {content}
      </StyledPurpleSecondaryButton>
    );
  },
);
